import { createModuleStore } from './utils'

export const createTrackedItemsStore = (storeId, cfg = {}, state = {}, actions = {}, form = {}) => {
  const defaultState = {
    showModal: false,
    selectedItem: null,
  }

  return createModuleStore(
    storeId,
    cfg,
    {
      ...defaultState,
      ...state,
    },
    actions,
    form
  )
}
